var A;!function(A){A.MODAL="MODAL",A.STYLED_MODAL="MODAL",A.SIDE_MODAL="SIDE_MODAL",A.FEATURE_MODAL="FEATURE_MODAL",A.STATE_MODAL="STATE_MODAL",A.TOASTER="TOASTER"}(A||(A={}));export{A as ComponentTypes};
